export default class ParallaxGraphic {
	protected subject: HTMLElement;
	protected target: HTMLElement;
	protected config = { ratio: .35 };
	protected margin: number;

	private callback(): void {
		const deltaTop = this.subject.getBoundingClientRect().bottom - window.innerHeight;
		if (deltaTop < 0) {
			this.target.style['transform'] = 'translateX(-50%) translateY(' + Math.floor((deltaTop + this.margin) * this.config.ratio * -1) + 'px)';
		}
	}
	constructor() {
		this.subject = document.querySelector('.masthead__image');
		this.target = document.querySelector('.masthead__graphic');

		let hasIntersectionObserver = ('IntersectionObserver' in window);
		if (!this.subject || !this.target || !hasIntersectionObserver) return;

		var computedStyle = window.getComputedStyle(this.target);
		this.margin = parseInt(computedStyle.getPropertyValue('margin-top'), 10);

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					window.addEventListener("scroll", () => this.callback());
				} else {
					window.removeEventListener("scroll", () => this.callback());
				}
			});
		});
		observer.observe(this.subject);
	}
}
